import api from 'data/api';

export const loadUserDetails = api('GET /api/users/current');
export const loadUserPermissions = api('GET /api/users/current/permissions');
export const loadUserActive = api('GET /api/users/active');
export const impersonate = api('POST /api/impersonate');
